import { useContext, useEffect } from 'react';
import { useMenusTour } from 'src/lib/tours/useMenusTour';
import { AppContext } from '../../sporttia/all';
import { HeaderProvider } from '../HeaderContext';
import Footer from '../Footer';
import AppSidebar from './sidebar/AppSidebar';
import { SidebarStateProvider } from './sidebar/SidebarStateContext';
import PageHeader from './PageHeader';
import BottomNav from './BottomNav';
import CopilotLauncher from '../../components/copilot/CopilotLauncher';

/**
 * Armazón de las páginas del gestor: sidebar + cabecera + contenido + pie, con
 * la misma composición que sporttia-competitions.
 */
export default function SCLayout({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { startTour, isTourCompleted } = useMenusTour();

    // Un centro nuevo recibe el tour de bienvenida al entrar, si todavía no lo
    // ha hecho.
    useEffect(() => {
        if (cxt.zero && !isTourCompleted()) startTour();
    }, [cxt.zero, isTourCompleted, startTour]);

    return (
        <SidebarStateProvider>
            <HeaderProvider>
                <div className="flex min-h-svh w-full">
                    <AppSidebar />

                    <div className="bg-muted flex min-w-0 flex-1 flex-col">
                        <PageHeader />

                        <main className="mx-auto w-full max-w-(--content-max-width) flex-1 px-6 pb-(--bottom-nav-height)">
                            {children}
                        </main>

                        <Footer />
                        <BottomNav />
                    </div>
                </div>
                <CopilotLauncher />
            </HeaderProvider>
        </SidebarStateProvider>
    );
}
